var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCosts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 94,
    viewBox: "0 0 95 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.7874 43.2257C87.4482 39.9023 85.5226 36.7989 83.1136 34.0843V19.4903C83.1136 17.0626 82.0121 14.8077 80.0865 13.2991C78.1926 11.8181 75.7718 11.2839 73.4262 11.8299C66.1953 13.5388 60.7711 17.6007 57.8669 23.403H36.6179C26.3916 23.403 17.2114 27.9521 11.185 35.0664C6.43041 34.379 7.00492 27.3235 11.7912 27.3314C16.9697 27.3118 16.9737 19.4942 11.7912 19.4746C-0.828227 19.4353 -4.56848 36.7831 6.76719 41.9018C-0.20221 56.1227 5.85986 74.4369 19.7155 82.0187V82.329C19.7234 95.4931 38.496 98.5062 42.8107 86.2574H52.094C56.4088 98.5141 75.1814 95.4853 75.1893 82.329V81.9676C81.3703 78.4203 86.1684 72.9323 88.7874 66.4347C92.0403 65.7473 95 63.1034 95 58.7586V50.9018C95 46.557 92.0363 43.9132 88.7874 43.2257ZM71.2272 50.9018C66.0447 50.8783 66.0447 43.0686 71.2272 43.045C76.4097 43.0686 76.4097 50.8783 71.2272 50.9018ZM23.8876 17.5575C21.6609 -4.40616 54.5545 -6.53143 55.3786 15.5462H36.6219C32.1803 15.5462 27.9052 16.2729 23.8876 17.5575Z",
    fill: "#58A291"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCosts);
export default __webpack_public_path__ + "static/media/icon-costs.12362be04bb702dcba2efce829916393.svg";
export { ForwardRef as ReactComponent };